import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TicketCloseComponent } from './ticket-close.component';

const routes: Routes = [{ path: '', component: TicketCloseComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TicketCloseRoutingModule { }
